import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const SlashForwardNewIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props} ref={ref}>
        <path
            // eslint-disable-next-line max-len
            d='M8.47231 21C7.77846 21 7.31305 20.2875 7.59189 19.6521L14.6479 3.57507C14.8013 3.22566 15.1468 3 15.5283 3C16.2222 3 16.6876 3.71252 16.4088 4.34788L9.35272 20.4249C9.19937 20.7743 8.85389 21 8.47231 21Z'
            fill='currentColor'
        />
    </svg>
));
